import { render, staticRenderFns } from "./JokerCard.vue?vue&type=template&id=07d7afb6&"
import script from "./JokerCard.vue?vue&type=script&lang=js&"
export * from "./JokerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports